export default "__VITE_ASSET__DlvroVof__"